import React ,{ useEffect, useState} from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useNavigate, Link } from "react-router-dom";
import { stringify } from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { GetItemsAction } from "../../redux/actions/UserActions";
import { Helmet } from 'react-helmet';
import './my-items.css';

type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};
interface ItemListResponse {
  data: {
    rows: any[];
    count: number;
  };
}
const MyItems: React.FC = () => {

    const dispatch = useDispatch<any>();
    const [soeContent, setSoeContent] = useState<SeoContent | null>(null);
    const [dataList, setDataList] = useState<ItemListResponse | null>(null);
    //const [loading, setLoading] = useState<boolean>(true);
    const {data ,status , loading, error} = useSelector((state: any) => state.getItemsState || []);

    useEffect(() => {
    dispatch(GetItemsAction({}));
    }, [dispatch])

    useEffect(() => {
    console.log("Orders : " , data);
    if ( status && data?.data) {
        setDataList(data);
    }
    }, [status,data])

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'My Items'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'E-learning Platform'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

      <div className="container py-5">
          <div className="row">

              <Sidebar />

              <div className="col-lg-9">
                  <div className="main-content">
                      <h2 className="mb-4">My Items</h2>

                      {/* <div className="d-flex justify-content-between align-items-center mb-4">
                          <div className="filter-buttons">
                              <a href="#" className="btn btn-outline-primary active">All Items</a>
                              <a href="#" className="btn btn-outline-primary">In Progress</a>
                              <a href="#" className="btn btn-outline-primary">Completed</a>
                          </div>
                          <form className="d-flex w-25">
                              <input className="form-control me-2" type="search" placeholder="Search items..." aria-label="Search" />
                          </form>
                      </div> */}

                      <div className="row">
                            {(dataList as any)?.data?.rows.length > 0 ? (
                                (dataList as any)?.data?.rows?.map((item: any) => (
                                    <div className="item-row col-md-4 mb-4" key={item.id}>
                                        <div className="card course-card h-100">
                                            {/* <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" className="course-img" alt="Data Science" /> */}
                                            <span className="cart-custom-icon-item course-img" >
                                                {item?.category?.icon}
                                            </span>
                                            <div className="card-body">
                                                <h5 className="course-title">{item?.category?.name}</h5>
                                                <p className="course-instructor">{item?.category?.single_line}</p>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    {/* <div className="course-progress text-primary">75% Complete</div> */}
                                                    {/* <a href="#" className="btn btn-sm btn-outline-primary">Continue</a> */}
                                                    <Link style={{"width":"100%"}} className="btn btn-sm btn-outline-primary" to={"/"+item?.category?.slug}>Continue</Link>
                                                </div>
                                                {/* <div className="progress mt-2">
                                                    <div className="progress-bar" role="progressbar" style={{width:"75%"}} aria-valuenow={75} aria-valuemin={0} aria-valuemax={100}></div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                            ))
                          ) : (
                            <div className="content-container empty-state" >
                                <i className="bi bi-cart-x empty-state-icon"></i>
                                <h3 className="mb-3">No Items found</h3>
                                <p className="text-muted mb-4">
                                  You haven't placed any items yet. Browse our artifacts to get
                                  started.
                                </p>
                                <Link style={{width:"35%"}} to={"/"} className="btn btn-primary"><i className="bi bi-search me-2"></i>Explore Artifacts</Link>
                              </div>
                            )}


                          {/* <div className="col-md-4 mb-4">
                              <div className="card course-card h-100">
                                  <img src="https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" className="course-img" alt="Machine Learning" />
                                  <div className="card-body">
                                      <h5 className="course-title">Machine Learning with Python</h5>
                                      <p className="course-instructor">Prof. Michael Chen</p>
                                      <div className="d-flex justify-content-between align-items-center">
                                          <div className="course-progress text-primary">42% Complete</div>
                                          <a href="#" className="btn btn-sm btn-outline-primary">Continue</a>
                                      </div>
                                      <div className="progress mt-2">
                                          <div className="progress-bar" role="progressbar" style={{width:"42%"}} aria-valuenow={42} aria-valuemin={0} aria-valuemax={100}></div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div className="col-md-4 mb-4">
                              <div className="card course-card h-100">
                                  <img src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" className="course-img" alt="Web Development" />
                                  <div className="card-body">
                                      <h5 className="course-title">Advanced Web Development</h5>
                                      <p className="course-instructor">Alex Rodriguez</p>
                                      <div className="d-flex justify-content-between align-items-center">
                                          <div className="course-progress text-success">100% Complete</div>
                                          <a href="#" className="btn btn-sm btn-outline-success">View Certificate</a>
                                      </div>
                                      <div className="progress mt-2">
                                          <div className="progress-bar bg-success" role="progressbar" style={{width:"100%"}} aria-valuenow={100} aria-valuemin={0} aria-valuemax={100}></div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div className="col-md-4 mb-4">
                              <div className="card course-card h-100">
                                  <img src="https://images.unsplash.com/photo-1626785774573-4b799315345d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" className="course-img" alt="Cloud Computing" />
                                  <div className="card-body">
                                      <h5 className="course-title">Cloud Computing Essentials</h5>
                                      <p className="course-instructor">Dr. Emily Wilson</p>
                                      <div className="d-flex justify-content-between align-items-center">
                                          <div className="course-progress text-primary">25% Complete</div>
                                          <a href="#" className="btn btn-sm btn-outline-primary">Continue</a>
                                      </div>
                                      <div className="progress mt-2">
                                          <div className="progress-bar" role="progressbar" style={{width:"25%"}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}></div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div className="col-md-4 mb-4">
                              <div className="card course-card h-100">
                                  <img src="https://images.unsplash.com/photo-1582213782172-ac1f2378875e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" className="course-img" alt="Project Management" />
                                  <div className="card-body">
                                      <h5 className="course-title">Agile Project Management</h5>
                                      <p className="course-instructor">Sophia Davis</p>
                                      <div className="d-flex justify-content-between align-items-center">
                                          <div className="course-progress text-success">100% Complete</div>
                                          <a href="#" className="btn btn-sm btn-outline-success">View Certificate</a>
                                      </div>
                                      <div className="progress mt-2">
                                          <div className="progress-bar bg-success" role="progressbar" style={{width:"100%"}} aria-valuenow={100} aria-valuemin={0} aria-valuemax={100}></div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div className="col-md-4 mb-4">
                              <div className="card course-card h-100">
                                  <img src="https://images.unsplash.com/photo-1616401931320-b46187768e82?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" className="course-img" alt="Digital Marketing" />
                                  <div className="card-body">
                                      <h5 className="course-title">Digital Marketing Strategy</h5>
                                      <p className="course-instructor">Mark Taylor</p>
                                      <div className="d-flex justify-content-between align-items-center">
                                          <div className="course-progress text-primary">60% Complete</div>
                                          <a href="#" className="btn btn-sm btn-outline-primary">Continue</a>
                                      </div>
                                      <div className="progress mt-2">
                                          <div className="progress-bar" role="progressbar" style={{width:"60%"}} aria-valuenow={60} aria-valuemin={0} aria-valuemax={100}></div>
                                      </div>
                                  </div>
                              </div>
                          </div> */}
                      </div>
                  </div>
              </div>

          </div>
      </div>

      <Footer />
    </>
  );
};

export default MyItems;
